import { MessageCircle } from "lucide-react";
import { generalWhatsAppUrl } from "@/data/products";

export default function FloatingWhatsApp() {
  return (
    <a
      href={generalWhatsAppUrl()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 left-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#1fa855] text-white shadow-xl shadow-black/25 transition-transform hover:scale-105"
      aria-label="Chat with RIMBARA MAJU on WhatsApp"
      data-testid="floating-whatsapp-button"
    >
      <MessageCircle className="h-6 w-6" aria-hidden="true" />
    </a>
  );
}
